// extracted by mini-css-extract-plugin
export default {"productGrid":"Wba-z","centerLink":"Xba-z","productSection":"Yba-z","item":"Zba-z","ctaButton":"_ba-z"};